/** Custom scheme of the app, declared in the Android manifest (and the iOS plist). */
export const APP_URL_SCHEME = 'com.volleystatspro.app';

const WEB_HOSTS: ReadonlySet<string> = new Set(['volleystatspro.com', 'www.volleystatspro.com']);

/**
 * In-app route for a URL the app was opened with, or `null` when it is not ours.
 * Accepts the website's links (App Links / Universal Links) and the custom
 * scheme, in both its `scheme://route` and `scheme:///route` forms.
 */
export function deepLinkToPath(rawUrl: string): string | null {
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return null;
  }
  if (url.username || url.password) return null;

  let pathname: string;
  if (url.protocol === 'https:' && WEB_HOSTS.has(url.hostname) && !url.port) {
    pathname = url.pathname;
  } else if (url.protocol === `${APP_URL_SCHEME}:`) {
    // Non-special scheme: `scheme://invitations/abc` parses « invitations » as the host.
    pathname = `/${url.host}${url.pathname}`.replace(/^\/+/, '/');
  } else {
    return null;
  }

  // `//evil.example` would leave the app once handed to the router.
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return null;
  return `${pathname}${url.search}${url.hash}`;
}
